// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"57b7d90e","457":"c462025b"}[chunkId] + ".chunk.js";
};